"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var app_definitions_1 = require("./app-definitions");
exports.SERVER_BASE_URL = 'https://apps.wix.com/events-server';
exports.getBillingUrl = function (msid, referral) {
    return "https://www.wix.com/store/plans?v=1&appDefId=" + app_definitions_1.EVENTS_APP_ID + "&siteGuid=" + msid + (referral ? "&referralAdditionalInfo=" + referral : '') + "#/";
};
